import React from 'react';
import ObjectsContainer from './ObjectsContainer';
import Loading from 'components/common/loading';
import * as Styles from '../style';

const ObjectsList = ({ isLoading, objectArr, mainRefetch }) => {
  if (isLoading) {
    return <Loading gap={50} />;
  }
  return (
    <Styles.ObjectGrid>
      {objectArr?.map((item, index) => (
        <ObjectsContainer item={item} key={index} mainRefetch={mainRefetch} />
      ))}
    </Styles.ObjectGrid>
  );
};

export default ObjectsList;
